import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
})
export class StatusComponent implements OnInit {
  @ViewChild('resetPasswordHeader') resetPasswordHeader: HeaderComponent;
  @Input() isModifyPwd: boolean;
  constructor() { }

  ngOnInit() {}

}
